
import { Component, Vue } from 'vue-property-decorator';
import OsAppBar from '@/components/app/OsAppBar.vue';
import OsGlobalDialogs from '@/components/app/OsGlobalDialogs.vue';
import { JwtUtil } from '@/utils/JwtUtil';
import OsTrialBanner from '@/components/app/OsTrialBanner.vue';

@Component({
  components: { OsTrialBanner, OsGlobalDialogs, OsAppBar }
})
export default class DefaultLayout extends Vue {
  appIsReady = false;

  async mounted() {
    const decodedJwtPayload = JwtUtil.getDecodedPayload();

    await this.$store.dispatch('user/fetchLoggedInUserData', {
      customerId: decodedJwtPayload?.CustomerId,
      appuserId: decodedJwtPayload?.AppUserId
    });
    this.appIsReady = true;
  }
}
